import { Component, Input } from '@angular/core';

/**
 * `<app-submission-abstract-display>` — apresentação READ-ONLY do texto do
 * resumo. Passo 2 da migração pra `<app-submission-export-view>`.
 *
 * O SPAN "Resumo." (`.section-lead.abstract-lead`) permanece no paper-info
 * pois é MEDIDO em runtime (setando `--abstract-lead-w` no `.abstract-block`
 * pai) e é usado nos DOIS modos (visão + edição). Este componente entra só
 * NO LUGAR do `<div class="abstract-text">` da visão read-only. Herda
 * `--abstract-lead-w` do ancestral via cascade de CSS custom property.
 */
@Component({
  selector: 'app-submission-abstract-display',
  templateUrl: './submission-abstract-display.component.html',
  styleUrls: ['./submission-abstract-display.component.scss'],
})
export class SubmissionAbstractDisplayComponent {
  /** Texto do resumo. Pode vir undefined durante o setter inicial → o
   *  `*ngIf` no template evita render vazio. */
  @Input() text: string | null | undefined;
}
